import {Grid, makeStyles, Typography} from "@material-ui/core";
import React from 'react';
import group_icon from "../../../Icons/Group-icon.png";
import Group from "../../../Domain/Models/Group";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  root: {
    margin: 'auto',
    justifyContent: 'center',
  },
  groupIcon: {
    margin: 'auto',
    display: 'flex',
    maxWidth: '35px'
  },
  groupName: {
    color: '#FFFFFF'
  }
}));

export interface GroupElementProps
{
  group: Group;
}

export default function GroupElement(props: GroupElementProps)
{
  const classes = useStyles();
  const {group} = props;

  return (
    <div className={classes.root}>
        <img src={group_icon} alt="Group" className={classes.groupIcon}/>
        <Typography className={classes.groupName} component="p" variant="caption" align='center'>
          {group.playerPairs.map(x => x.name).join(' vs. ')}
        </Typography>
    </div>
  )
}